import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import {
  addQueueAccessoriesCount,
  resetQueueAccessoriesCount,
} from '../../../store/emarsys/action';
import { Dispatch } from 'react';

export default function eventClickAccessories(
  dispatch: Dispatch<any>,
  sku: string,
  skuPrice: string,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  customerNo: string,
  sectionName: string,
  buttonName: string,
  carModel: string[] = [],
  newParams?: Record<string, string | number | boolean>
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isAccessoriesDetailActive = getFlagValue(FLAG_ENUM.EMARSYS_ACCESSORIES_DETAIL);
  if (!isFlagActive || !isAccessoriesDetailActive) return;
  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: 'aksesoris & spareparts detail page',
    page_title: pageTitle,
    page_url: window.location.href,
    menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
    menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() || '',
    menu_cat_lvl3: breadcrumbItems?.[3]?.name?.toUpperCase() || '',
    sku,
    sku_price: skuPrice,
    section_name: sectionName,
    button_name: buttonName,
    ...newParams,
  };

  if (carModel?.length > 0) {
    valueClickAction.car_model = carModel?.join(', ');
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueueAccessoriesCount());
  } else {
    dispatch(addQueueAccessoriesCount());
  }
}
